import { useState, useRef } from "react";
import { initMantenimientoMensualFree, CATEGORIAS_MANTENIMIENTO_MENSUAL_FREE, MESES_FREE } from '../constants/freeFormConfig';
import { Inp, Sel, ChecklistSeccion, FirmaCanvas, CampoPDF, ChecklistSeccionPDF, FirmaPDF, ModalCuotaFree } from './ui/FormControls';
import { generarPdfFree, nombreArchivoPdfFree } from '../services/pdf-free';
import { useDescargaFree } from '../hooks/useDescargaFree';

export const FreeMantenimientoMensualTab = () => {
  const [form, setForm] = useState(initMantenimientoMensualFree());
  const [completado, setCompletado] = useState(false);
  const [pdfDoc, setPdfDoc] = useState(null);
  const printRef = useRef(null);
  const { intentarDescarga, generando, bloqueo, cerrarBloqueo } = useDescargaFree();
  const listo = form.responsable.trim() && form.firma;
  const validadoPorTexto = `Validado por: ${form.responsable || "—"} · ${new Date().toLocaleDateString("es-ES")} ${new Date().toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}`;

  const finalizar = () => intentarDescarga(async () => {
    const doc = await generarPdfFree(printRef.current);
    setPdfDoc(doc);
    setCompletado(true);
  });

  const descargar = () => pdfDoc?.save(nombreArchivoPdfFree("mantenimiento_mensual", `${form.mes}_${form.anio}`));

  return (
    <>
      {completado ? (
        <div className="space-y-3 text-center">
          <p className="text-2xl">✅</p>
          <h3 className="font-bold text-gray-800">Checklist mensual completado</h3>
          <p className="text-sm text-gray-500">{validadoPorTexto}</p>
          <button onClick={descargar} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 transition-all">Descargar PDF</button>
          <button onClick={() => setCompletado(false)} className="text-xs text-gray-400 hover:text-gray-600">← Volver al checklist</button>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <Inp label="Responsable *" value={form.responsable} onChange={v => setForm(f => ({ ...f, responsable: v }))} placeholder="Nombre" />
            <Inp label="Año" value={form.anio} onChange={v => setForm(f => ({ ...f, anio: v }))} placeholder="2026" />
            <Sel label="Mes" value={form.mes} onChange={v => setForm(f => ({ ...f, mes: v }))} options={MESES_FREE} />
          </div>

          <div className="space-y-3">
            {CATEGORIAS_MANTENIMIENTO_MENSUAL_FREE.map(({ sec, items }) => (
              <ChecklistSeccion
                key={sec}
                titulo={sec}
                color="bg-slate-100 text-slate-800"
                items={items}
                value={form.categorias[sec]}
                onChange={val => setForm(f => ({ ...f, categorias: { ...f.categorias, [sec]: val } }))}
                conObservaciones
              />
            ))}
          </div>

          <div>
            <label className="text-xs font-semibold text-gray-600 uppercase">Observaciones</label>
            <textarea className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" rows={3} value={form.observaciones} onChange={e => setForm(f => ({ ...f, observaciones: e.target.value }))} />
          </div>

          <FirmaCanvas onChange={firma => setForm(f => ({ ...f, firma }))} />
          {form.firma && <p className="text-xs text-gray-500 text-center">{validadoPorTexto}</p>}

          <button onClick={finalizar} disabled={!listo || generando} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 disabled:opacity-40 transition-all">
            {generando ? "Generando PDF..." : "Finalizar checklist →"}
          </button>
        </div>
      )}

      {/* Vista oculta de solo lectura, usada únicamente para generar el PDF */}
      <div ref={printRef} style={{ position: "absolute", left: "-9999px", top: 0, width: 800 }} className="bg-white p-6 space-y-4">
        <h2 className="font-bold text-gray-800 border-b pb-2">📋 Mantenimiento Instalaciones — Mensual</h2>
        <div className="grid grid-cols-2 gap-3">
          <CampoPDF label="Responsable" value={form.responsable} />
          <CampoPDF label="Mes / Año" value={`${form.mes} ${form.anio}`} />
        </div>
        <div className="space-y-3">
          {CATEGORIAS_MANTENIMIENTO_MENSUAL_FREE.map(({ sec, items }) => (
            <ChecklistSeccionPDF key={sec} titulo={sec} color="bg-slate-100 text-slate-800" items={items} value={form.categorias[sec]} conObservaciones />
          ))}
        </div>
        <CampoPDF label="Observaciones" value={form.observaciones} />
        <FirmaPDF dataUrl={form.firma} />
        <p className="text-xs text-gray-500 text-center">{validadoPorTexto}</p>
      </div>

      <ModalCuotaFree bloqueo={bloqueo} onClose={cerrarBloqueo} />
    </>
  );
};
